import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import {
  fundsAggregatedStatusesMap,
  fundsBonusSystemStates
} from '../../constants';

import styles from './index.module.css';

const StatusLabel = ({ status, className = '', classNames = {}, textSize }) => {
  const { t } = useI18n();
  const { labelContainer, labelText } = classNames;

  return (
    <Box
      align="center"
      className={clsx(
        styles[status],
        styles.container,
        className,
        labelContainer
      )}
    >
      <AText
        breed="BU"
        size={textSize || 'xs'}
        className={clsx(styles.text, labelText)}
        data-testid="status-label"
      >
        {t(
          `web.personaloffice.bonuses.status.${
            status ===
            fundsAggregatedStatusesMap[fundsBonusSystemStates.COMPLETED]
              ? 'completed'
              : status
          }`
        )}
      </AText>
    </Box>
  );
};

export default StatusLabel;
